import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useToast,
} from '@chakra-ui/react';
import React from 'react';

import { InvalidateItemModalProps } from 'types/plaid';

import {
  GetAllPlaidInstitutionAccountsDocumentGQLType,
  GetPlaidLinkTokenDocumentGQLType,
  useInvalidatePlaidItemMutation,
} from 'borrower/domains/bankIntegrations/requests/plaid.gql.generated';
import {
  GetBankAccountsByCreditFacilityIdDocumentGQLType,
  GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType,
} from 'packages/bankAccounts/requests/bankAccounts.gql.generated';
import { successToastConfig } from 'packages/common-frontend/constants';

export const InvalidateItemModal = ({
  isOpen,
  onClose,
  name,
  plaidItemId,
}: InvalidateItemModalProps) => {
  const toast = useToast();

  const [
    disconnectPlaidItem,
    { loading: disconnectPlaidItemLoading },
  ] = useInvalidatePlaidItemMutation({
    refetchQueries: [
      GetPlaidLinkTokenDocumentGQLType,
      GetAllPlaidInstitutionAccountsDocumentGQLType,
      GetBankAccountsByCreditFacilityIdDocumentGQLType,
      GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType,
    ],
  });

  const invalidateItem = async () => {
    await disconnectPlaidItem({ variables: { plaidItemId } });
    toast({
      ...successToastConfig,
      title: `${name} integration successfully removed`,
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Removal</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to remove your {name} integration?
        </ModalBody>
        <ModalFooter>
          <Button
            mr={3}
            isLoading={disconnectPlaidItemLoading}
            onClick={invalidateItem}
          >
            Remove
          </Button>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
